webpackJsonp([218297198804973],{

/***/ 3668:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/seated-cable-rows"},"frontmatter":{"title":"Seated Cable Rows","date":null}}}]}},"pathContext":{"tag":"seated-cable-rows"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-seated-cable-rows-12ca2f1123f39bfc9a34.js